import debug from 'debug';

const log = debug('WindowWidthChecker');

export class WindowWidthChecker {
	
	constructor(options) {
		this.deviceMaxWidth = options ? options.deviceMaxWidth : 450;
		this.isDevice = window.innerWidth < this.deviceMaxWidth;
		log(`window.innerWidth: ${ window.innerWidth }, this.deviceMaxWidth: ${ this.deviceMaxWidth }`);
	}

	GetState() {
		if (window.innerWidth < this.deviceMaxWidth && !this.isDevice) {
			this.isDevice = true;
			this.isDesktop = false;
		}

		if (window.innerWidth >= this.deviceMaxWidth && !this.isDesktop) {
			this.isDesktop = true;
			this.isDevice = false;
		}

		return {
			isDevice: this.isDevice,
			isDesktop: this.isDesktop,
		}
	}
}

export default WindowWidthChecker;
